<template>
    <div>
        <div class="flex flex-between flex-v-center">
            <el-page-header @back="goBack" title="">
                <div slot="content" class="flex flex-v-center" v-if="source">
                    <h2><span class="color-primary">{{ source_index + (page - 1) * 20 + 1 }}</span> / {{ total }}</h2>
                </div>
            </el-page-header>


            <!-- <div class="margin-x" style="flex:1">
                <el-progress :show-text="false" :percentage="50"></el-progress>
            </div> -->

            <div class="flex flex-v-center">
                <el-tooltip :content="$t('练习列表')">
                    <i style="font-size: 30px;" @click="dialogVisible1 = true"
                        class="el-icon-document margin-r pointer"></i>
                </el-tooltip>


                <i style="font-size: 30px;" class="el-icon-timer"></i>
                <h3 style="letter-spacing: 2px;margin-left: 10px;"> <span>{{ timeText }}</span></h3>
            </div>
        </div>

        <div class="game flex flex-column flex-v-center flex-h-center" style="height: 80vh;">
            <div v-if="source">
                <h3 class="center">{{ source.title }} #{{ source.no }}</h3>
            </div>

            <div v-if="source" class="margin-t">
                <h3 class="center">{{ source.words_zh }}</h3>
            </div>
            <div v-loading="loading" class="flex flex-v-center flex-h-center"
                style="gap: 20px;margin-top: 80px; flex-wrap: wrap; height: 200px;">
                <div :class="{ 'shake': shakeFlag && word.input != word.word }" class="pointer"
                    v-for="(word, i) in words" :key="`${source_index}_${i}`" @click="word_index = i">
                    <h3 class="center" :style="{ opacity: (answerFlag || overFlag) ? 1 : 0 }">/{{ word.phonetic[0] }}/
                    </h3>
                    <h1 :style="{ color: word.color }" style="height: 60px; line-height: 60px;" class="center">{{
                        answerFlag ? word.word : word.input
                    }}
                    </h1>
                    <div
                        :style="{ backgroundColor: word_index == i ? '#e6a13c' : (word.color || ($store.state.theme == 'dark' ? '#fff' : '#999')), height: word_index == i ? '4px' : '2px' }">
                    </div>
                </div>
            </div>

            <div class="flex flex-v-center" style="gap: 40px;margin-top: 80px;">
                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">p</el-tag> 上一题</div>
                    <i @click="prev()" class="el-icon-arrow-left color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>

                <div class="flex flex-between flex-v-center" style="gap: 40px;">
                    <el-button :disabled="word_index == -1" class="flex flex-v-center pointer" @click="play(1)"
                        type="primary" round style="gap: 5px;">
                        <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">w</el-tag> {{ $t('播放单词') }}
                    </el-button>

                    <el-button :disabled="!source || overFlag" class="flex flex-v-center pointer" @click="play()"
                        type="primary" round style="gap: 5px;">
                        <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">s</el-tag> {{ $t('播放句子') }}
                    </el-button>

                    <div @mousedown="show_answer()" @mouseout="answerFlag = false" @mouseup="answerFlag = false">
                        <el-button :disabled="!source || overFlag" class="flex flex-v-center pointer" type="primary"
                            round style="gap: 5px;">
                            <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">a</el-tag> {{ $t('查看答案') }}
                        </el-button>
                    </div>

                    <el-button :disabled="!source" @click="submit()" class="flex flex-v-center" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="small">Enter</el-tag> {{ overFlag ? $t('下一题') : $t('提交') }}
                    </el-button>

                </div>

                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">n</el-tag>
                        {{ $t('下一题') }}</div>
                    <i @click="next()" class="el-icon-arrow-right color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>
            </div>

            <audio ref="audio" preload="metadata" style="display:none" :src="src">
                浏览器太老咯，请升级浏览器吧~
            </audio>

            <audio ref="type" preload="metadata" style="display:none" src="/audio/type.mp3">
                浏览器太老咯，请升级浏览器吧~
            </audio>
        </div>

        <el-dialog v-if="dialogVisible" width="60%" top="5%" center :title="$t('练习结算')" :visible.sync="dialogVisible">
            <el-descriptions :colon="false" label-class-name="center" content-class-name="center" direction="vertical"
                class="margin-top" :column="3">
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-timer" style="font-size: 20px;"></i>
                        <h4>{{ $t('用时时长') }}</h4>
                    </template>
                    <h2> {{ time }}s</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-reading" style="font-size: 20px;"></i>
                        <h4>{{ $t('单词数量') }}</h4>
                    </template>
                    <h2>{{ words.length }}</h2>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-magic-stick" style="font-size: 20px;"></i>
                        <h4>{{ $t('练习得分') }}</h4>
                    </template>
                    <h2>{{ score }}</h2>

                </el-descriptions-item>
            </el-descriptions>


            <el-descriptions :title="$t('数据分析')" :colon="false" label-class-name="center" content-class-name="center"
                direction="vertical" class="margin-top" :column="4">
                <el-descriptions-item :span="4">
                    <el-table style="width:100%" border
                        :data="[{ tag: $t('提交次数'), key: 'submitCount' }, { tag: $t('重听次数'), key: 'playCount' }, { tag: $t('答案次数'), key: 'answerCount' }]">
                        <el-table-column align="center" label="" prop="tag">

                        </el-table-column>
                        <el-table-column align="center" v-for="(word, i) in words" :key="i" :label="word.word"
                            :width="word.width">
                            <template slot-scope="scope">
                                <span size="small">{{ word[scope.row.key] }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-descriptions-item>


                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="score == words.length ? 'green' : (score / words.length) > 0.5 ? '#e6a23c' : 'red'"
                            :percentage="parseInt(score / words.length * 100)"></el-progress>
                    </template>
                    {{ $t('正确率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle"
                            :color="submitCount == 1 ? 'green' : (submitCount == 2 ? '#e6a23c' : 'red')"
                            :percentage="parseInt(1 / submitCount * 100)"></el-progress>
                    </template>
                    {{ $t('成功率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle" :color="answerCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="answerCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="parseInt((1 - 1 / (answerCount + 1)) * 100)"></el-progress>
                    </template>
                    {{ $t('查看率') }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <el-progress :width="100" type="circle" :color="playCount == 1 ? '#e6a23c' : 'red'"
                            :define-back-color="playCount == 0 ? 'green' : '#f0f0f0'"
                            :percentage="parseInt((1 - 1 / (playCount + 1)) * 100)"></el-progress>
                    </template>
                    {{ $t('重听率') }}

                </el-descriptions-item>

            </el-descriptions>

            <div slot="footer">
                <el-button type="primary" class="margin-x" @click="prev()" round><i class="el-icon-back"></i>{{
                    $t('上一题') }}</el-button>
                <el-button class="margin-x" type="primary" @click="reDo()" round>{{ $t('再来一次') }}<i
                        class="el-icon-refresh-right"></i></el-button>
                <el-button class="margin-x" type="primary" @click="next()" round>{{ $t('下一题') }}<i
                        class="el-icon-right"></i></el-button>
            </div>
        </el-dialog>


        <el-dialog width="65%" center :title="$t('练习列表') + '(' + total + ')'" @close="close()"
            :visible.sync="dialogVisible1">
            <div style="max-height: 50vh;min-height: 20vh; overflow-y: scroll;" v-loading="loading">
                <el-table :show-header="last_source_index != -1" :data="list">
                    <el-table-column>
                        <div slot="header" class="flex flex-between flex-v-center"
                            v-if="list.length > 1 && last_source_index != -1">
                            <div>{{ $t('上次练习到') }} #{{ list[last_source_index].no }} {{ list[last_source_index].words_en
                            }}
                            </div>
                            <el-button @click="go()" size="small" type="primary">{{ $t('继续练习') }}<i
                                    class="el-icon-right"></i></el-button>
                        </div>
                        <div @click="set_source_index(scope.$index)" slot-scope="scope"
                            class="flex flex-between flex-v-center">
                            <h2 class="flex flex-v-center pointer" style="word-break: keep-all;"
                                :class="{ 'color-primary': source && source.id == scope.row.id }">
                                <el-tag size="small" type="primary">#{{
                                    scope.row.no }}</el-tag> <span class="margin-l">{{ scope.row.words_en }}</span>
                            </h2>
                            <i v-if="source && source.id == scope.row.id" style="font-size: 20px;"
                                class="el-icon-timer color-primary"></i>
                            <i v-else class="el-icon-right"></i>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="center">
                <el-pagination background :current-page="page" @current-change="pageChange"
                    layout="prev, pager, next, jumper" :pageSize="20" :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>

</template>
<script>
export default {
    name: 'Game',
    data() {
        return {
            dialogVisible: false,
            dialogVisible1: false,
            words: [],
            page: 1,
            list: [],
            total: 9999,
            source_index: -1,
            last_source_index: -1,
            word_index: -1,
            source: null,
            src: null,
            answerFlag: false,
            time: 0,
            score: 0,
            timer: null,
            timeText: "00:00:00",
            submitFlag: false,
            shakeFlag: false,
            checkFlag: false,
            overFlag: false,
            loading: true,
            submitCount: 0,
            answerCount: 0,
            playCount: 0
        };
    },

    computed: {
        tableData: function () {
            return []
        }
    },

    watch: {
        shakeFlag: function (newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.shakeFlag = false
                }, 150);
            }
        },

        dialogVisible1: function (newVal) {
            if (newVal) {
                this.stopTimer()
            } else {
                this.startTimer()
            }
        },

        source_index: function (newVal) {
            if (newVal >= 0 && this.list.length > 0 && newVal < this.list.length) {
                this.reDo()
            }
        },
    },
    mounted() {
        if (this.$store.getters.getRole() == 0) {
            this.loading = false
            this.$vip_alert("此功能", '', () => {
                this.$router.replace('/main')
            })
            return;
        }
        if (localStorage.getItem('game_page') != undefined) {
            this.page = Number(localStorage.getItem('game_page'))
        }

        if (localStorage.getItem('game_source_index') != undefined) {
            this.last_source_index = Number(localStorage.getItem('game_source_index'))
        }

        document.addEventListener('keydown', this.handleKeyDown)
        document.addEventListener('keyup', this.handleKeyUp)


        this.get_list(1);
    },
    beforeDestroy() {
        this.stopTimer();
        document.removeEventListener('keyup', this.handleKeyUp)
        document.removeEventListener('keydown', this.handleKeyDown)

    },
    methods: {
        goBack() {
            this.$router.back()
        },

        go() {
            this.set_source_index(this.last_source_index)
            this.last_source_index = -1
        },

        close() {
            if (this.last_source_index != -1 && this.source_index == -1) {
                this.source_index = this.last_source_index
            }
            this.last_source_index = -1
        },

        set_source_index(index) {

            this.source_index = index
            this.dialogVisible1 = false
        },

        pageChange(page) {
            this.page = page
            this.get_list()
        },

        reDo() {
            this.dialogVisible = false
            this.word_index = 0
            this.time = 0
            this.score = 0
            this.submitFlag = false
            this.answerFlag = false
            this.overFlag = false
            this.checkFlag = false
            this.submitCount = 0
            this.playCount = 0
            this.answerCount = 0
            this.$refs.audio.pause()
            this.source = this.list[this.source_index];
            this.get_words();
        },

        getWidth(word) {
            const measureDom = document.createElement('span');
            measureDom.style.cssText = `
                font-weight:700;
                font-size:14px;
                visibility:hidden;
                position:absolute;
                white-space:nowrap;
                `;
            document.body.appendChild(measureDom);
            // 获取单词真实宽度
            measureDom.innerText = word;
            const width = measureDom.offsetWidth
            return width + 30
        },

        submit() {
            if (this.overFlag) {
                this.next()
                return
            }
            if (this.checkFlag) return
            this.submitCount++
            this.checkFlag = true
            this.shakeFlag = true
            this.word_index = -1
            let flag = false
            this.words.forEach(word => {
                if (word.color != 'green') word.submitCount++
                if (word.input == word.word) {
                    word.color = "green"
                    if (!this.submitFlag) {
                        this.score++
                    }
                } else {
                    word.color = "red"
                    flag = true
                }
            })
            this.submitFlag = true
            if (flag) {
                this.play1()
            } else {
                this.stopTimer()
                this.overFlag = true
                this.dialogVisible = true
                this.play1(1)
            }
        },

        prev() {
            if (this.source_index > 0) {
                this.source_index--
            } else if (this.page > 1) {
                this.page--
                this.source_index = 19
                this.get_list()
            }
        },

        next() {
            if (this.source_index < this.total - 1) {
                this.source_index++
            } else if (this.page < Math.ceil(this.total / 20)) {
                this.page++
                this.source_index = 0
                this.get_list()
            }
        },

        startTimer() {
            this.stopTimer()
            this.timer = setInterval(() => {
                this.time++;
                // 格式化时间 00:00:00
                let h = parseInt(this.time / 3600)
                    .toString()
                    .padStart(2, "0");
                let m = parseInt((this.time % 3600) / 60)
                    .toString()
                    .padStart(2, "0");
                let s = parseInt(this.time % 60)
                    .toString()
                    .padStart(2, "0");
                this.timeText = `${h}:${m}:${s}`;
            }, 1000);
        },

        stopTimer() {
            if (this.timer) clearInterval(this.timer);
            this.timer = null
        },

        play(flag) {
            if (flag) {
                this.words[this.word_index].playCount++
                this.src = this.$host + "/api/word/audio/" + this.words[this.word_index].word + '/1';
            } else {
                this.src = this.$host + "/api/audio/" + this.source.no + "/Andy";
            }
            this.$refs.audio.currentTime = 0
            this.$nextTick(() => {
                this.$refs.audio.play();
            })
        },

        play1(flag) {
            if (flag) {
                this.src = '/web/audio/success.mp3';
            } else {
                this.src = '/web/audio/fail.mp3';
            }
            this.$refs.audio.currentTime = 0
            this.$nextTick(() => {
                this.$refs.audio.play();
            })
        },

        setPrevIndex() {
            for (let i = this.word_index - 1; i >= 0; i--) {
                if (this.words[i].color != 'green') {
                    this.word_index = i;
                    break;
                }
            }

        },

        setNextIndex() {

            if (this.word_index == this.words.length - 1) {
                this.submit()
                return
            }

            for (let i = this.word_index + 1; i < this.words.length; i++) {
                if (this.words[i].color != 'green') {
                    this.word_index = i;
                    if (this.submitFlag) {
                        this.words[this.word_index].input = ''
                    }
                    break;
                }
            }

        },

        handleKeyUp() {
            // 判断：Ctrl + A 松开
            this.answerFlag = false
        },

        handleKeyDown(e) {
            if (this.overFlag) {
                if (e.code == 'Enter' || e.code == 'Backspace') {
                    this.next()
                }
                return
            }
            if (e.code != 'Enter') {
                this.checkFlag = false
            }
            if (e.code == 'Space') {
                this.setNextIndex()
            } else if (e.code == 'Backspace') {
                if (this.words[this.word_index].input) {
                    this.words[this.word_index].input = this.words[this.word_index].input.slice(0, -1);
                } else {
                    this.setPrevIndex()
                }
                this.$refs.type.currentTime = 0;
                this.$refs.type.play();
            } else if (e.code == 'Enter') {
                this.submit()
            } else if (e.ctrlKey) {
                if (e.key == "w") {
                    this.play(1);
                } else if (e.key == "s") {
                    this.play();
                } else if (e.key == "a") {
                    this.show_answer()
                } else if (e.key == "n") {
                    this.next()
                } else if (e.key == "p") {
                    this.prev()
                }
            } else if (/^[A-Za-z']$/.test(e.key)) {
                if (this.word_index == -1) {
                    this.word_index = this.words.findIndex(v => v.input != v.word)
                    if (this.word_index == -1) return
                    this.words[this.word_index].input = ''
                }
                this.words[this.word_index].input += e.key;
                this.words[this.word_index].color = ""
                this.$refs.type.currentTime = 0;
                this.$refs.type.play();
            }
            e.preventDefault()
        },

        show_answer() {
            if (this.answerFlag) return
            this.answerCount++
            this.words.forEach(item => {
                if (item.word != item.input) {
                    item.answerCount++
                }
            })
            this.answerFlag = true
        },

        get_list(flag) {
            this.loading = true
            this.$http.post('/api/source/list', { tag: 'WFD', page: this.page }).then(res => {
                this.list = res.data;
                this.total = res.total
                if (flag) this.dialogVisible1 = true
                this.loading = false

            });
        },
        get_words() {
            this.loading = true
            this.$http.post('/api/word/words', { content: this.source.words_en.replace(/\./g, '') }).then(data => {
                this.words = data.map(item => {
                    item.submitCount = 0
                    item.playCount = 0
                    item.answerCount = 0
                    item.color = ''
                    item.input = '';
                    item.width = this.getWidth(item.word)
                    return item;
                });

                this.play();
                this.startTimer()
                this.loading = false

                localStorage.setItem('game_page', this.page)
                localStorage.setItem('game_source_index', this.source_index)
            });
        }
    },
};
</script>

<style scoped>
/* 拼写错误：波浪下划线 + 抖动动画 */
.shake {
    animation: shake 0.1s ease-in-out;
}

/* 左右轻微抖动 */
@keyframes shake {
    0% {
        transform: translateX(0px);
    }

    25% {
        transform: translateX(-6px);
    }

    75% {
        transform: translateX(6px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>